/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import React from 'react';

export default (): JSX.Element => (
  <svg width={36} height={33} xmlns="http://www.w3.org/2000/svg">
    <g fill="#243858">
      <path d="M7.83 17.28a7.83 7.83 0 100 15.66 7.83 7.83 0 000-15.66zm0 3.63a4.2 4.2 0 00-4.2 4.2.5.5 0 11-1 0 5.2 5.2 0 015.2-5.2.5.5 0 110 1zm20.34-3.63a7.83 7.83 0 100 15.66 7.83 7.83 0 000-15.66zm0 3.63a4.2 4.2 0 00-4.2 4.2.5.5 0 11-1 0 5.2 5.2 0 015.2-5.2.5.5 0 110 1zM20.35 8.16a3.71 3.71 0 00-2.14-.68h-.42a3.71 3.71 0 00-2.14.68v6.56a3.7 3.7 0 012.14-.72h.42a3.7 3.7 0 012.14.68V8.16z" />
      <path
        d="M15.65 8.16v-5.4a2.7 2.7 0 00-3.19-2.7h-.05a2.61 2.61 0 00-1.78 1.66L8.91 6.3a1.88 1.88 0 01-1.12 1.11 1.88 1.88 0 00-1.09 1l-5.13 12a7.82 7.82 0 0114.08 4.69v-17 .06zm13.65.27a1.88 1.88 0 00-1.09-1 1.88 1.88 0 01-1.12-1.13l-1.71-4.56A2.61 2.61 0 0023.59.07h-.05a2.7 2.7 0 00-3.19 2.7v22.34a7.82 7.82 0 0114.08-4.69L29.3 8.43z"
        opacity={0.5}
      />
    </g>
  </svg>
);
